<template>
  <div class="aside-options">
    <button class="btn mt-5" @click="$emit('back')">
      <i class="icon-arrow-left"></i>
      <span>Início</span>
    </button>

    <router-link
      class="btn mt-5 home"
      :to="{ name: 'product-details', params: { id: $route.params.id } }"
    >
      <i class="fa-light fa-box-open"></i>
      <span>Painel do produto</span>
    </router-link>
    <router-link class="btn" :to="{ name: 'product-basic-info' }">
      <i class="fa-light fa-list"></i>
      <span>Informações básicas</span>
    </router-link>
    <router-link class="btn" :to="{ name: 'product-coproducers' }">
      <i class="fa-light fa-handshake"></i>
      <span>Coprodutores</span>
    </router-link>

    <button class="btn" @click="$emit('toggleContext', 'config')">
      <i class="fa-light fa-gear"></i>
      <span class="">Configurações</span>
      <i
        class="icon-angle-right"
        :class="{
          'rotate-90-clock': openContext === 'config'
        }"
      ></i>
    </button>
    <div
      v-if="openContext === 'config' && (showMenu || lockedMenu)"
      class="pl-5"
    >
      <router-link
        v-for="route in configRoutes"
        :key="route.route"
        :to="{ name: route.route }"
        class="btn"
        @click.native="$emit('closeMenu')"
      >
        <span>{{ route.title }}</span>
      </router-link>
    </div>

    <button class="btn" @click="$emit('toggleContext', 'content')">
      <i class="fa-light fa-book"></i>
      <span class="">Área de Membros</span>
      <i
        class="icon-angle-right"
        :class="{
          'rotate-90-clock': openContext === 'content'
        }"
      ></i>
    </button>
    <div
      v-if="openContext === 'content' && (showMenu || lockedMenu)"
      class="pl-5"
    >
      <router-link
        :to="{
          name: 'product-member-area-setup',
          params: { id: $route.params.id }
        }"
        class="btn"
        @click.native="$emit('closeMenu')"
      >
        <span>Configurações</span>
      </router-link>
      <router-link
        :to="{
          name: 'product-member-area-modules',
          params: { id: $route.params.id }
        }"
        class="btn"
        @click.native="$emit('closeMenu')"
      >
        <span>Conteúdo</span>
      </router-link>
      <router-link
        :to="{
          name: 'product-member-area-categories',
          params: { id: $route.params.id }
        }"
        class="btn"
        @click.native="$emit('closeMenu')"
      >
        <span>Categorias</span>
      </router-link>
      <router-link
        :to="{
          name: 'product-member-area-students',
          params: { id: $route.params.id }
        }"
        class="btn"
        @click.native="$emit('closeMenu')"
      >
        <span>Alunos</span>
      </router-link>
      <router-link
        :to="{
          name: 'product-member-area-groups',
          params: { id: $route.params.id }
        }"
        class="btn"
        @click.native="$emit('closeMenu')"
      >
        <span>Turmas</span>
      </router-link>
      <router-link
        :to="{
          name: 'product-member-area-comments',
          params: { id: $route.params.id }
        }"
        class="btn"
        @click.native="$emit('closeMenu')"
      >
        <span>Comentários</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    showMenu: {
      type: Boolean,
      default: false
    },
    lockedMenu: {
      type: Boolean,
      default: false
    },
    indicatorClasses: {
      type: String,
      default: ""
    },
    openContext: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapState("product", ["product"]),
    configRoutes() {
      return [
        {
          icon: "fa-light fa-ticket-perforated",
          title: "Ingressos",
          route: "event-lots",
          type_product: ["onsite_event"]
        },
        {
          icon: "fa-light fa-users",
          title: "Participantes",
          route: "event-participants",
          type_product: ["onsite_event"],
          permissions: ["gerenciar-participantes"]
        },
        {
          icon: "fa-light fa-file-invoice-dollar",
          title: "Configurar Checkout",
          route: "config-checkout",
          permissions: ["configurar-checkout"]
        },
        {
          icon: "fa-light fa-wand-magic-sparkles",
          title: "Personalizar Checkout",
          route: "product-customize-checkout",
          permissions: ["configurar-checkout"]
        },
        {
          icon: "fa-light fa-link",
          title: "Links de Divulgação",
          route: "product-links"
        },
        {
          icon: "fa-light fa-dollar-sign",
          title: "Precificação e Ofertas",
          route: "product-prices",
          permissions: ["gerenciar-ofertas"],
          type_product: ["online_course"]
        },
        {
          icon: "fa-light fa-dollar-sign",
          title: "Precificação e Planos",
          route: "product-plans",
          permissions: ["gerenciar-ofertas"],
          type_product: ["signature"]
        },
        {
          icon: "fa-light fa-ticket",
          title: "Cupons de desconto",
          route: "product-coupons",
          permissions: ["gerenciar-ofertas"],
          type_product: ["online_course"]
        },
        {
          icon: "fa-light fa-filter-circle-dollar",
          title: "Funil de vendas",
          route: "product-upsell",
          type_product: ["online_course", "signature"]
        },
        {
          icon: "fa-light fa-bullseye-pointer",
          title: "Link one click buy",
          route: "product-oneclickbuy"
        },
        {
          icon: "fa-light fa-crosshairs",
          title: "Pixel de rastreamento",
          route: "product-edit-pixel"
        },
        {
          icon: "fa-light fa-display-chart-up-circle-dollar",
          title: "Api de conversões",
          route: "product-analytics"
        }
      ].filter(opt => {
        if (
          opt.type_product &&
          !opt.type_product.includes(this.product.type_product)
        )
          return false;

        if (
          opt.permissions &&
          opt.permissions.find(p => !this.$permissions.hasPermission(p))
        )
          return false;

        return true;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.aside-options {
  width: 100%;
  transition: width 0.15s;

  ::v-deep.btn {
    width: 100%;
    color: rgba(255, 255, 255, 0.8);
    display: flex;
    cursor: pointer;
    padding-top: 12px;
    padding-bottom: 12px;
    justify-content: flex-start;

    &.router-link-active:not(.home),
    &.router-link-exact-active {
      @media screen and (min-width: 576px) {
        border-right: 4px solid white;
      }
      @media screen and (max-width: 575px) {
        border-left: 4px solid white;
      }
    }

    span {
      margin-left: 12px;
      white-space: nowrap;
      flex: 1 1 auto;
      text-align: left;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    &:hover {
      color: white;
      .news {
        i {
          font-size: 0;
          min-width: 0;
          width: 0px;
          opacity: 0;
        }
        span {
          font-size: 14px;
          opacity: 1;
        }
      }
    }

    i {
      font-size: 20px;
      min-width: 46px;

      &.menu {
        font-size: 32px;
        line-height: 44px;
        color: rgba(51, 51, 51, 0.6);
      }
    }
    .news {
      padding: 4px;
      height: 30px;
      display: flex;
      border-radius: 8px;
      align-items: center;
      background: #423d4d;
      transition: 0.1s opacity;
      border: 1px solid rgba(230, 213, 255, 0.85);
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      span,
      i {
        margin: 0 !important;
        transition: all 0.3s;
        color: rgba(230, 213, 255, 0.85) !important;
      }
      i {
        min-width: 24px;
      }
      span {
        opacity: 0;
        font-size: 0;
      }
    }
    &:has(.news) {
      span {
        flex: 1;
      }
    }
  }

  .active-item-indiciator {
    font-weight: bold;
    border-right: 4px solid white;
    background: rgba(255, 255, 255, 0.05);
    @media screen and (min-width: 576px) {
      padding-left: 13px;
    }
    @media screen and (max-width: 575px) {
      padding-left: 9px;
    }
  }
}
</style>
